import React, { useState } from 'react';
import { array, object, string } from 'yup';
import propTypes from 'prop-types';

import Review from '../ReviewPage/Review';
import { FormStepper } from '../FormStepper';
import { BasicDetails } from '../Steps/BasicDetails';
import { PanelDetails } from '../Steps/PanelDetails';
import { QuestionDetails } from '../Steps/QuestionDetails';
import VideoPageSetup from '../Steps/VideoPageSetup';
import { PostExposureSurvey } from '../Steps/PostExposureSurveyDetails';
import { ScreeningSurvey } from '../Steps/ScreeningSurveyDetails';
import { useSelector } from 'react-redux';
export default function GamingStepper({
  onAddNewStudySubmit,
  environmentData,
  locationTypes,
  languageTypes,
  questionTypes,
  brandTypes,
  adTypes,
  respondentTypes,
  defaultValues,
  basicDetailsValidationSchema,
  panelDetailsValidationSchema,
  questionDetailsValidationSchema,
  screeningSurveyValidationSchema,   
  postExposureValidationSchema, 
  history,
}) {
  const [stepImperatively, setStepImperatively] = useState(null);
  const companyUsersRaw = useSelector((state) => state.studyData.companyUsers);
  const loggedInUser = useSelector((state) => state.userData.userData);
        
  const safeUsers = Array.isArray(companyUsersRaw)
    ? companyUsersRaw
    : Array.isArray(companyUsersRaw?.data)
    ? companyUsersRaw.data
    : [];
        
  const userOptions = safeUsers.map((u) => ({
  id: u.user_id || u.id,
  name: u.first_name && u.last_name
  ? `${u.first_name} ${u.last_name}`
  : u.name || u.username,
  description: u.email || "",
  }));
  return (
    <FormStepper
      stepImperatively={stepImperatively}
      setStepImperatively={setStepImperatively}
      initialValues={{
        ...defaultValues,
        panel_seconds_before_move_next: -1,
        cachepage_stim_list: [{
          cachepage_url: '',
          stim_list: [
            {
              stim_url: '',
              // brand_id: null,
              // ad_type_id: '',
            },
          ],
        }],
        study_type_id: 13,
        override_owner_id: loggedInUser?.user_id || null,
      }}
      onSubmit={async (values) => {
        await onAddNewStudySubmit(values, history);
      }}
    >
      <BasicDetails
        title='Tell us about your study'
        label='Basic Details'
        validationSchema={basicDetailsValidationSchema}
        {...{environmentData, locationTypes, languageTypes, respondentTypes, userOptions}}
      />
      {/* <QuestionDetails
        validationSchema={questionDetailsValidationSchema}
        title='What surveys will you use?'
        label='Question Details'
        {...{questionTypes}}
      /> */}
      <ScreeningSurvey
              title="What screening survey will you use?"
              label="Screening Survey"
              validationSchema={screeningSurveyValidationSchema}
              {...{ questionTypes }}
            />
      <PanelDetails
        validationSchema={panelDetailsValidationSchema}
        title='Tell us about your recruitment'
        label='Panel Details'
      />
      <VideoPageSetup stimOnly
        validationSchema={object().shape({
          cachepage_stim_list: array(
            object({
              // cachepage_url: string()
              //   .url('Must be a valid URL')
              //   .max(512, 'Too Long!')
              //   .required('Required'),
              stim_list: array(
                object({
                  stim_url: string()
                    .url('Must be a valid URL')
                    .max(512, 'Too Long!'),
                })
              ),
            })
          ),
        })}
        title='Great! Now setup your your page'
        label='Video Setup'
        // {...{adTypes, brandTypes}}
      />
      <PostExposureSurvey
              title="What post-exposure survey will you use?"
              label="Post Exposure Survey"
              validationSchema={postExposureValidationSchema}
            />
      <Review
        title='Your project is ready for review'
        label='Review'
        setStepImperatively={setStepImperatively}
        {...{
          setStepImperatively,
          labels: [
            'Basic Details',
            'Question Details',
            'Panel Details',
            'Video Setup',
          ],
        }}
      />
    </FormStepper>
  );
}

GamingStepper.propTypes = {
  onAddNewStudySubmit: propTypes.func,
  languageTypes: propTypes.object,
  environmentData: propTypes.object,
  locationTypes: propTypes.object,
  questionTypes: propTypes.object,
  mediaData: propTypes.object,
  brandTypes: propTypes.object,
  adTypes: propTypes.object,
  respondentTypes: propTypes.object,
  defaultValues: propTypes.object,
  basicDetailsValidationSchema: propTypes.object,
  panelDetailsValidationSchema: propTypes.object,
  questionDetailsValidationSchema: propTypes.object,
  history: propTypes.object,
};
